import { RouteConfig } from 'vue-router';

export default [
  {
    name: 'companies-list',
    path: '/companies',
    component: () => import(/* webpackChunkName: "companies" */ '../components/companies/CompaniesList.vue'),
  },
] as RouteConfig[];
